module.exports = __webpack_public_path__ + "static/img/iongi-isaiah.928fd1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iongi-isaiah.jpg
// module id = LRy5
// module chunks = 0